import React, { useState } from "react";
import { Layout, Menu, Input, Table, Typography, Button, Dropdown, Space, Tag } from "antd";
import { SearchOutlined, LogoutOutlined, UserOutlined, DownOutlined, FileExcelOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx';

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

const menu = (
  <Menu>
    <Menu.Item key="logout" icon={<LogoutOutlined />}>Выйти</Menu.Item>
  </Menu>
);

const generateMockData = () => {
  const regions = ["Астана", "Алматы", "Шымкент", "Караганда", "Тараз"];
  const directions = ["IT", "Медицина", "Педагогика", "Строительство", "Экономика"];
  const leagues = ["Лидеры", "Опорные", "Социальные", "Целевые"];

  const data = [];
  for (let i = 1; i <= 30; i++) {
    const region = regions[i % regions.length];
    const direction = directions[i % directions.length];
    const league = leagues[i % leagues.length];
    const score = Math.floor(Math.random() * 41) + 60; // 60 - 100
    data.push({
      key: String(i),
      region,
      college: `Колледж №${i}`,
      direction,
      ownership: i % 2 === 0 ? "Государственная" : "Частная",
      territory: i % 3 === 0 ? "Село" : "Город",
      criteriaScores: { "Студенты": Math.floor(Math.random() * 16), "Педагоги": Math.floor(Math.random() * 16) },
      indicatorScores: { "WorldSkills": Math.floor(Math.random() * 10), "Опыт": Math.floor(Math.random() * 5) },
      score,
      league,
      contact: `Ответственный ${i}, +7 700 000 00${i.toString().padStart(2, '0')}`
    });
  }
  return data;
};

const OperatorDashboard = () => {
  const [search, setSearch] = useState("");
  const [selectedRegion, setSelectedRegion] = useState(null);

  const regions = ["Астана", "Алматы", "Шымкент", "Караганда", "Тараз"];
  const data = generateMockData();

  const filteredData = data.filter(
    (item) =>
      (!selectedRegion || item.region === selectedRegion) &&
      (item.college.toLowerCase().includes(search.toLowerCase()) ||
        item.direction.toLowerCase().includes(search.toLowerCase()) ||
        item.region.toLowerCase().includes(search.toLowerCase()))
  );

  const columns = [
    { title: "Регион", dataIndex: "region", key: "region" },
    { title: "Наименование колледжа", dataIndex: "college", key: "college" },
    { title: "Направление подготовки", dataIndex: "direction", key: "direction" },
    { title: "Форма собственности", dataIndex: "ownership", key: "ownership" },
    { title: "Территориальная принадлежность", dataIndex: "territory", key: "territory" },
    { title: "Общий балл", dataIndex: "score", key: "score", render: (score) => <Tag color={score >= 80 ? "green" : "blue"}>{score}</Tag> },
    { title: "Лига", dataIndex: "league", key: "league", render: (league) => <Tag color="purple">{league}</Tag> },
    { title: "Контакты", dataIndex: "contact", key: "contact" },
    {
      title: "Действие",
      key: "action",
      render: (_, record) => (
        <Button type="link" onClick={() => window.location.href = `/college/${record.key}`}>Просмотр</Button>
      )
    }
  ];

  const handleExportExcel = () => {
    const exportData = filteredData.map(row => ({
      "Регион": row.region,
      "Наименование колледжа": row.college,
      "Направление подготовки": row.direction,
      "Форма собственности": row.ownership,
      "Территориальная принадлежность": row.territory,
      ...Object.fromEntries(Object.entries(row.criteriaScores).map(([k, v]) => [`Балл по критерию '${k}'`, v])),
      ...Object.fromEntries(Object.entries(row.indicatorScores).map(([k, v]) => [`Балл по показателю '${k}'`, v])),
      "Общий балл": row.score,
      "Лига": row.league,
      "Контактные данные ответственного": row.contact
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Колледжи");
    XLSX.writeFile(wb, "Рейтинг_колледжей.xlsx");
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={{ background: '#fff', padding: '0 32px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
        <Title level={4} style={{ margin: 0 }}>Панель оператора</Title>
        <Dropdown overlay={menu} placement="bottomRight">
          <Button type="text" icon={<UserOutlined />}>
            <Space>
              Аккаунт
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Header>

      <Layout hasSider>
        <Sider width={240} style={{ background: '#fafafa', borderRight: '1px solid #f0f0f0' }}>
          <div style={{ padding: 16, fontWeight: 600 }}>Регионы</div>
          <Menu
            mode="inline"
            onClick={({ key }) => setSelectedRegion(key)}
            selectedKeys={[selectedRegion]}
          >
            {regions.map((region) => (
              <Menu.Item key={region}>{region}</Menu.Item>
            ))}
          </Menu>
        </Sider>

        <Content style={{ padding: 32 }}>
          <Input
            size="large"
            placeholder="Поиск по ключевым словам (регион, колледж, направление)"
            prefix={<SearchOutlined />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            allowClear
            style={{ marginBottom: 24 }}
          />

          <Button type="primary" icon={<FileExcelOutlined />} onClick={handleExportExcel} style={{ marginBottom: 16 }}>
            Экспорт в Excel
          </Button>

          <Table
            columns={columns}
            dataSource={filteredData}
            bordered
            pagination={{ pageSize: 10 }}
          />
        </Content>
      </Layout>
    </Layout>
  );
};

export default OperatorDashboard;
